import React, {
//	useState,
//	useEffect,
} from 'react';
// import {
// 	//useSelector,
// 	useDispatch,
// } from 'react-redux';
import { Messages } from 'components/messages/messages.js';
//import { actionUserLogin } from './actions';
//import { actionSetMessage, actionResetMessage } from '#app/components/messages/actions.js'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

export const UserProfileModal = (props) => {
	//const [username, setUsername] = useState( '' );
	//const [password, setPassword] = useState( '' );
	//const [values, setValues] = useState({});
	//const dispatch = useDispatch()

	const handleChange = (evt) => {
		evt.persist();
		//setValues(values => ({ ...values, [evt.target.name]: evt.target.value }));
	};
	const handleSubmit = (evt) => {
		evt.preventDefault()
		//console.log('actionUserLogin')
		console.log(evt.target)
		//dispatch(actionUserLogin(values))
	}
	return (
		<Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
		<Modal.Header closeButton>
			<Modal.Title id="contained-modal-title-vcenter">
				User Profile
			</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<Form onSubmit={ handleSubmit }>
				<Messages />
				{/* <h1>User Profile</h1> */}
				to be completed<br />
				<Row>
					<Col sm='4'><p style={{paddingTop: '0.3em'}}>Username</p></Col>
					<Col sm='8'>
						<Form.Control
							id = 'username'
							name = 'username'
							placeholder="Enter username..."
							onChange = {handleChange}
						/>
					</Col>
				</Row>
				{/* <Row>
					<Col sm = { 4 }>
						<p style={{paddingTop: '0.3em'}}>Password</p></Col>
					<Col sm = { 8 }>
					<Form.Control
						type='password'
						name='password'
						//placeholder='Password'
						placeholder='bar'
						//value={ values.password }
						onChange={ handleChange }
					/>
					</Col>
				</Row> */}
			</Form>
		</Modal.Body>
		<Modal.Footer>
			{/* <input type='submit'/> */}
			<Button type='submit' variant="info" >Save</Button>&nbsp;
			<Button onClick={props.onHide}>Close</Button>
		</Modal.Footer>
	  </Modal>
	)
}